class LazyloadImage {
	
	constructor(){
		this.lazyloadElement = document.querySelectorAll(`[data-lazyload]`);
		this.init();
	}


	init(){

		for(const item of this.lazyloadElement){
			if(item.hasAttribute('data-lazyload-autostart')){
				this.loadImages(item);
			}
		}

		document.addEventListener('visible', (event)=>{
			if( event.target.getAttribute('data-lazyload-src') ){
				this.loadImages(event.target);
			}
		});
	}


	loadImages(element){
		const imageURL     = element.getAttribute('data-lazyload-src');
		const image        = new Image();
					image.src    = imageURL;
					image.onload = ()=> {
			if(element.nodeName.toLowerCase() === 'img'){
				element.setAttribute('src', imageURL);
			}else{
				element.style.backgroundImage = `url(${imageURL})`;
			}
			element.setAttribute('data-lazyload-state', 'loaded');
		};
	}
}

export const lazyloadImage = new LazyloadImage();